import { render, staticRenderFns } from "./add-teams-modal-user-list-invite.vue?vue&type=template&id=20f9280a&scoped=true"
import script from "./add-teams-modal-user-list-invite.vue?vue&type=script&lang=js"
export * from "./add-teams-modal-user-list-invite.vue?vue&type=script&lang=js"
import style0 from "./add-teams-modal-user-list-invite.vue?vue&type=style&index=0&id=20f9280a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9280a",
  null
  
)

export default component.exports